import React from "react";
import { Button, useTheme } from "@mui/material";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";

const ExportToPDF = ({ data, columns, fileName }) => {
  const theme = useTheme();

  const getExportValue = (row, col) => {
    if (typeof col.renderExport === "function") {
      return col.renderExport(row);
    }

    const value =
      typeof col.renderer === "function" ? col.renderer(row) : row[col.field];

    if (React.isValidElement(value)) return "";
    if (typeof value === "object" && value !== null)
      return JSON.stringify(value);
    return value ?? "";
  };

  const handleExport = () => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }
    const doc = new jsPDF();

    const header = columns.map((col) => col.name);
    const body = data.map((row) =>
      columns.map((col) => getExportValue(row, col))
    );

    autoTable(doc, {
      head: [header],
      body: body,
      styles: { fontSize: 8 },
      theme: "striped",
    });

    doc.save(`${fileName}.pdf`);
  };

  return (
    <Button
      type="submit"
      variant="contained"
      sx={{
        backgroundColor: `${theme?.customSettings?.themeColor}`,
        color: "#FFF",
        padding: "7px 20px",
        fontWeight: "500",
        textTransform: "none",
        fontSize: "16px",
        float: "right",
        marginRight: "10px",
      }}
      onClick={handleExport}
    >
      Export as PDF
    </Button>
  );
};

export default ExportToPDF;
